module.exports = __webpack_public_path__ + "img/pause-circle-orange.8ea57c4e.png";